import { UserRole } from 'libs/~core/src';
import { RedirectTo, RedirectToFn } from 'ngx-permissions';

export type SidebarLink = {
  id: string;
  label: string;
  url: string;
  iconUrl?: string;
  hasBadge?: boolean;
  exactActive?: boolean;
  children?: SidebarLink[];
  permissions?: {
    only?: string | string[];
    except?: string | string[];
    redirectTo?: RedirectTo | RedirectToFn;
  };
};

export const SIDEBAR_LINKS: SidebarLink[] = [
  {
    id: 'dashboard',
    label: 'Tableau de bord',
    iconUrl: 'assets/icons/sidebar/grid.svg',
    url: '/',
    exactActive: true
  },
  {
    id: 'admin-advertisers',
    label: 'Annonceurs',
    iconUrl: 'assets/icons/sidebar/annonceur.svg',
    url: '/advertisers/list',
    exactActive: true,
    permissions: {
      only: [UserRole.ROLE_ADMIN, UserRole.ROLE_SUPER_ADMIN],
      except: [UserRole.ROLE_ANALYST]
    },
    children: [
      {
        id: 'advertisers-list',
        label: 'Liste des annonceurs',
        url: '/advertisers/list',
        iconUrl: '',
        exactActive: true
      },
      {
        id: 'advertisers-brands',
        label: 'Marques',
        url: '/advertisers/brands',
        iconUrl: '',
        exactActive: true
      },
      {
        id: 'advertisers-groups',
        label: 'Groupes',
        url: '/advertisers/groups',
        iconUrl: '',
        exactActive: true
      },
      {
        id: 'advertisers-sectors',
        label: 'Secteurs',
        url: '/advertisers/sectors',
        iconUrl: '',
        exactActive: true
      },
      {
        id: 'advertisers-sub-sectors',
        label: 'Sous-secteurs',
        url: '/advertisers/sub-sectors',
        iconUrl: '',
        exactActive: true
      }
    ]
  },
  {
    id: 'medias',
    label: 'Médias',
    iconUrl: 'assets/icons/sidebar/poster.svg',
    url: '/medias/screens',
    exactActive: true,
    permissions: {
      only: [UserRole.ROLE_ADMIN, UserRole.ROLE_SUPER_ADMIN],
      except: [UserRole.ROLE_ANALYST]
    },
    children: [
      {
        id: 'medias-screens',
        label: 'Ecrans',
        url: '/medias/screens',
        exactActive: true,
        permissions: {
          only: [UserRole.ROLE_SUPER_ADMIN, UserRole.ROLE_ADMIN]
        }
      },
      {
        id: 'medias-supports',
        label: 'Supports',
        url: '/medias/supports',
        exactActive: true,
        permissions: {
          only: [UserRole.ROLE_SUPER_ADMIN, UserRole.ROLE_ADMIN]
        }
      },
      {
        id: 'medias-locations',
        label: 'Emplacements',
        url: '/medias/locations',
        iconUrl: '',
        exactActive: true,
        permissions: {
          only: [UserRole.ROLE_SUPER_ADMIN, UserRole.ROLE_ADMIN]
        }
      }
    ]
  },
  {
    id: 'campaigns',
    label: 'Campagnes',
    iconUrl: 'assets/icons/sidebar/le-marketing-daffiliation.svg',
    url: '/campaigns/list',
    exactActive: true,
    permissions: {
      only: [UserRole.ROLE_SUPER_ADMIN, UserRole.ROLE_ADMIN],
      except: [UserRole.ROLE_ANALYST]
    },
    children: [
      // admin
      {
        id: 'admin-campaigns-list',
        label: 'Liste des campagnes',
        url: '/campaigns/list',
        exactActive: true,
        permissions: {
          only: [UserRole.ROLE_SUPER_ADMIN, UserRole.ROLE_ADMIN]
        }
      },
      {
        id: 'admin-campaigns-messages',
        label: 'Messages',
        url: '/campaigns/messages',
        exactActive: true,
        permissions: {
          only: [UserRole.ROLE_SUPER_ADMIN, UserRole.ROLE_ADMIN]
        }
      }
    ]
  },
  {
    id: 'ads',
    label: 'Publicités',
    iconUrl: 'assets/icons/sidebar/ads.svg',
    url: '/ads',
    exactActive: false,
    permissions: {
      only: [UserRole.ROLE_ADMIN, UserRole.ROLE_SUPER_ADMIN],
      except: [UserRole.ROLE_ANALYST]
    },
    children: [
      {
        id: 'admin-ads-list',
        label: 'Liste des publicités',
        url: '/ads/list',
        exactActive: true,
        permissions: {
          only: [UserRole.ROLE_SUPER_ADMIN, UserRole.ROLE_ADMIN]
        }
      },
      {
        id: 'admin-ads-types',
        label: 'Types de publicités',
        url: '/ads/types',
        exactActive: true,
        permissions: {
          only: [UserRole.ROLE_SUPER_ADMIN, UserRole.ROLE_ADMIN]
        }
      },
      {
        id: 'admin-ads-formats',
        label: 'Formats',
        url: '/ads/formats',
        exactActive: true,
        permissions: {
          only: [UserRole.ROLE_SUPER_ADMIN, UserRole.ROLE_ADMIN]
        }
      },
      {
        id: 'admin-ads-prices',
        label: 'Tarifs',
        url: '/ads/prices',
        exactActive: true,
        permissions: {
          only: [UserRole.ROLE_SUPER_ADMIN, UserRole.ROLE_ADMIN]
        }
      }
    ]
  },
  // data analyst
  {
    id: 'analyst-ads',
    label: 'Publicités',
    iconUrl: 'assets/icons/sidebar/ads.svg',
    url: '/analyst/ads',
    permissions: {
      only: [UserRole.ROLE_ANALYST]
    }
  },
  {
    id: 'subscriptions-plans',
    label: "Formules d'abonnements",
    iconUrl: 'assets/icons/sidebar/abonnement.svg',
    url: '/subscription-plans',
    permissions: {
      only: [UserRole.ROLE_ADMIN, UserRole.ROLE_SUPER_ADMIN],
      except: [UserRole.ROLE_ANALYST]
    }
  },
  {
    id: 'admin-subscribers',
    label: 'Clients',
    iconUrl: 'assets/icons/sidebar/users.svg',
    url: '/subscribers',
    permissions: {
      only: [UserRole.ROLE_ADMIN, UserRole.ROLE_SUPER_ADMIN],
      except: [UserRole.ROLE_ANALYST]
    }
  },
  {
    id: 'settings',
    label: 'Paramètres',
    iconUrl: 'assets/icons/sidebar/setting.svg',
    url: '/settings/administrators',
    permissions: {
      only: [UserRole.ROLE_ADMIN, UserRole.ROLE_SUPER_ADMIN],
      except: [UserRole.ROLE_ANALYST]
    }
  },

  // subscriber
  {
    id: 'subscriber-advertisers',
    label: 'Annonceurs',
    iconUrl: 'assets/icons/sidebar/annonceur.svg',
    url: '/subscriber/advertisers',
    permissions: {
      only: [UserRole.ROLE_SUBSCRIBER]
    }
  },

  {
    id: 'subscriber-ads',
    label: 'Publicités',
    iconUrl: 'assets/icons/sidebar/ads.svg',
    url: '/subscriber/ads',
    permissions: {
      only: [UserRole.ROLE_SUBSCRIBER]
    }
  },
  {
    id: 'subscriber-channels',
    label: 'Supports',
    iconUrl: 'assets/icons/sidebar/poster.svg',
    url: '/subscriber/channels',
    permissions: {
      only: [UserRole.ROLE_SUBSCRIBER]
    }
  }
];
